import PageShell from "@/components/primitives/PageShell";
import PageHead from "@/components/seo/PageHead";
import ContactSection from "@/sections/ContactSection";

export default function ContactPage() {
  return (
    <>
      <PageHead
        title="Suporte e contato | Alert AI"
        description="Fale com o time de especialistas da Alert AI: tire dúvidas, receba atendimento ou descubra como a inteligência artificial pode tornar seu ambiente mais seguro."
        path="/alertAI-contact"
      />
      <PageShell navbar="flow">
        <div className="pt-6 sm:pt-12">
          <ContactSection
            headingAs="h1"
            title="Fale com nosso time de especialistas."
            description="Precisa de suporte ou quer saber mais sobre nossas soluções de IA? Fale com nossa equipe para tirar dúvidas, receber atendimento ou descobrir como podemos ajudar seu negócio a crescer. Envie sua mensagem e retornaremos o mais breve possível."
          />
        </div>
      </PageShell>
    </>
  );
}
